module.exports = __webpack_public_path__ + "media/01.d59cdaf9.mp3";